// extracted by mini-css-extract-plugin
export default {"tabList":"TabList_tabList__zajb5","tab":"TabList_tab__Gnjrt"};